"use strict";

define('service/study',['appkit/service', 'underscore', '../model/study', '../model/document', '../model/workflow', '../libs/route.helper', 'app/study/detail/study.detail.controller'], function (Service, _, Study, Document, Workflow, RouteHelper, StudyDetailController) {
  var StudyService = Service.extend({
    createPDF: function createPDF(study, app) {
      var legacyController = new (StudyDetailController.extend({
          setupListeners: function setupListeners() {}
        }))(app.legacyApp),
        popup = app.request('pdf:popup');
      legacyController.setup($('<div/>'));
      legacyController.getStudyService().configure({
        studyId: study.get('id')
      });
      return legacyController.loadStudyProperties().tap(function () {
        return legacyController.generatePDFDocument(popup);
      })["finally"](legacyController.showLoading());
    },
    createSubmission: function createSubmission(study, template, user, documents) {
      var submission = new Document({
          studyId: study.get('id'),
          templateId: template.get('id'),
          templateRevisionNumber: template.get('revisionNumber')
        }),
        workflow = new Workflow(),
        person = user.person;
      return submission.save().promise().bind(this)["finally"](app.request('dimmer')).tap(function () {
        this.navigateToSubmission(submission);
      });
    },
    navigateToStudies: function navigateToStudies(options) {
      app.navigate(RouteHelper.resolve('study:list'), _.extend({}, {
        trigger: true
      }, options));
    },
    navigateToSubmission: function navigateToSubmission(submission) {
      var link = RouteHelper.createLink('submission:detail', submission, {
        documentId: 'id',
        studyId: 'studyId'
      });
      app.navigate(link, {
        trigger: true
      });
    },
    navigateToStudy: function navigateToStudy(study, options) {
      var link = RouteHelper.createLink('study:detail', study, {
        studyId: 'id'
      });
      app.navigate(link, _.extend({}, {
        trigger: true
      }, options));
    }
  });
  return StudyService;
});

